/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import logger from '@utils/logger';

import { BrandInitials, Brands } from '@/lib/constants';

/**
 * Returns the brand name for a given brand environment value.
 */
export function mapBrandEnvToBrand(brandEnv: string): Brands {
  switch (brandEnv) {
    case 'mayoral':
      return Brands.MAYORAL;
    case 'boston':
      return Brands.BOSTON;
    case 'hugandclau':
      return Brands.HUGANDCLAU;
    case 'abelandlula':
      return Brands.ABELANDLULA;
    default:
      logger.warn(
        `Brand "${brandEnv}" is not supported. Please use one of the following brands: ${Object.values(
          Brands,
        ).join(', ')}.`,
      );
      return Brands.MAYORAL;
  }
}

/**
 * Returns the brand initial for a given brand name.
 */
export function mapBrandToBrandInitial(brand: Brands): BrandInitials {
  switch (brand) {
    case Brands.MAYORAL:
      return BrandInitials.MAYORAL;
    case Brands.BOSTON:
      return BrandInitials.BOSTON;
    case Brands.HUGANDCLAU:
      return BrandInitials.HUGANDCLAU;
    case Brands.ABELANDLULA:
      return BrandInitials.ABELANDLULA;
    default:
      return BrandInitials.MAYORAL;
  }
}
